import React, {
  Fragment,
  useState,
  useContext,
  useCallback,
  useEffect,
} from "react";
import { Redirect } from "react-router-dom";
import { UrlServicesContext } from "components/UrlServicesContext";
import debounce from "lodash.debounce";

import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import axios from "axios";
import {
  Card,
  CardMedia,
  CardContent,
  Grid,
  Slide,
  Snackbar,
  Alert,
  TextField,
  Typography,
  CardActions,
  Button,
  Table,
  TableBody,
  TableCell,
  TableRow,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  FormLabel,
  //Select,
  //MenuItem,
} from "@mui/material";
import {
  Add,
  PermIdentityOutlined,
  Save,
  Close,
  AddCircle,
  Delete,
  CheckCircleOutline,
  KeyboardBackspace,
  QrCodeOutlined,
  AddCardOutlined,
  CalendarMonthOutlined,
  MailOutline,
} from "@mui/icons-material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Moment from "moment";

import successImg from "assets/img/success.gif";
import productImg from "assets/img/backgroundProduct.jpg";
import loaderGif from "assets/img/loading.gif";

import LoadPrefixes from "components/services/LoadPrefixes";
import ClientSearch from "views/dialog/ClientSearch";
import LoadTypeDependents from "components/services/LoadTypeDependents";

import {
  cardBodyStyle,
  ButtonStyle0,
  ButtonExit,
  blackColor,
} from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const StyledTableRow = styled(TableRow)({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#FAFAFA",
    },
  },
});

export default function MyAccount(props) {
  const classes = useStyles();
  const [clientsList, setClientsList] = useState(false);
  const [success, setSuccess] = useState(false);
  const [addPerson, setAddPerson] = useState(false);
  const [rowsItem, setrowsItem] = useState([]);
  const [dateBirthClient, setDateBirthClient] = useState();
  const [dateBirthDependent, setDateBirthDependent] = useState();
  const [loaderSave, setLoaderSave] = useState(false);
  const [loader, setLoader] = useState(true);
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(false);
  const [mensageSystem, setMensageSystem] = useState("");
  const [returnLogin, setReturnLogin] = React.useState(false);
  const [openAddRegister, setOpenAddRegister] = React.useState(false);
  const [dataClientSelect, setDataClientSelect] = React.useState(false);
  const [nullProducts, setNullProducts] = React.useState(false);
  const [viewDetailsItems, setViewDetailsItems] = React.useState(true);
  const [radioDocument, setRadioDocument] = React.useState("CI");
  const [radioExample, setRadioExample] = React.useState("MENSUAL");
  const [radioPay, setRadioPay] = React.useState("TC");
  const [radioPrices, setRadioPrices] = React.useState({});
  const [productInfo, setProductInfo] = React.useState(null);
  const [viewCashDiscount, setViewCashDiscount] = React.useState(false);

  const [alert, setAlert] = React.useState({
    openAlert: false,
    errorAlert: "error",
    mensaje: "",
  });

  const { urlServices, UserAuth } = useContext(UrlServicesContext);

  let keyAuthorization = UserAuth.Session;

  const [values, setValues] = useState({
    idClient: "",
    nameClient1: "",
    nameClient2: "",
    lastNameClient1: "",
    lastNameClient2: "",
    emailClient: "",
    documentIdClient: "",
    dateBirthClient: "",
    phoneClient: "",
    nameDependent1: "",
    nameDependent2: "",
    lastNameDependent1: "",
    lastNameDependent2: "",
    documentIdDependent: "",
    dateBirthDependent: "",
    typePerson: "",
    typePersonName: "",
    typePersonData: "",
    prefix: "",
    monthCollection: 1,
    prefixData: null,
    errorPrefix: false,
    errorNameClient1: false,
    errorLastNameClient1: false,
    errorDocumentIdClient: false,
    errorEmailClient: false,
    errorDateBirthClient: false,
    errorNameDependent1: false,
    errorLastNameDependent1: false,
    errorDocumentIdDependent: false,
    errorDateBirthDependent: false,
    errorTypePerson: false,
    errorPhoneClient: false,
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    RowsDatas();
  }, []);

  const RowsDatas = async () => {
    setLoader(true);

    try {
      const response = await axios.get(
        `${urlServices}clients/products-plans/company`,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        const transformedRows = response.data.products.map((data) => ({
          ...data,
          prices: parseJsonArray(data.prices),
        }));

        setRows({ products: transformedRows });
      }
    } catch (error) {
      if (error.response?.status === 404) {
        setNullProducts(true);
      } else if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }
    } finally {
      setLoader(false);
    }
  };

  const handleChange = useCallback((prop, value) => {
    setValues((prevValues) => ({
      ...prevValues,
      [prop]: value,
    }));

    // Solo usar debounce para realizar validaciones u otros efectos secundarios
    debounceValidation(prop, value);
  }, []);

  const debounceValidation = useCallback(
    debounce((prop, value) => {
      setValues((prevValues) => ({
        ...prevValues,
        errorNameClient1: false,
        errorLastNameClient1: false,
        errorDocumentIdClient: false,
        errorEmailClient: false,
        errorDateBirthClient: false,
        errorNameDependent1: false,
        errorLastNameDependent1: false,
        errorDocumentIdDependent: false,
        errorDateBirthDependent: false,
        errorTypePerson: false,
        errorPhoneClient: false,
      }));

      setAlert((prevAlert) => ({
        ...prevAlert,
        openAlert: false,
      }));
    }, 10),
    []
  );

  const handleChangeTypePerson = (data) => {
    setValues({
      ...values,
      typePerson: data !== null ? data.id : "",
      typePersonName: data !== null ? data.name : "",
      typePersonData: data !== null ? data : "",
      errorTypePerson: false,
    });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
  };

  const handleDateBirthChange = (data) => {
    const formattedDate = dayjs(data).format("YYYY-MM-DD");

    setValues({
      ...values,
      dateBirthClient: formattedDate,
      errorDateBirthClient: false,
    });

    setDateBirthClient(data);
  };

  const handleDateBirthDependentChange = (data) => {
    const formattedDate = dayjs(data).format("YYYY-MM-DD");

    setValues({
      ...values,
      dateBirthDependent: formattedDate,
      errorDateBirthDependent: false,
    });

    setDateBirthDependent(data);
  };

  const submitSave = async () => {
    setLoaderSave(true);

    if (dataClientSelect) {
      submitRegister();
      return;
    }

    try {
      const response = await axios.get(`${urlServices}clients/list`, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      });

      if (response.status === 200) {
        const responseData = response.data.some(
          (document) => document.documentId === values.documentIdClient
        );

        if (responseData) {
          window.scrollTo({ top: 0, behavior: "smooth" });
          setLoaderSave(false);
          setAlert({
            ...alert,
            openAlert: true,
            errorAlert: "error",
            mensaje:
              "Este cliente está registrado, vaya al botón de AGREGAR CLIENTE REGISTRADO o verificar que no esté inactivo en el módulo de clientes.",
          });
        } else {
          submitRegister();
        }
      }
    } catch (error) {
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setRows([]);
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setRows([]);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }

      setLoaderSave(false);
    }
  };

  const resultTotalPrice = (data) => {
    let subtotal = (parseFloat(data.priceSelect) * 12).toFixed(2);

    if (radioPay === "E") {
      subtotal = (
        subtotal -
        ((subtotal * parseFloat(UserAuth.cashDiscount)) / 100).toFixed(2)
      ).toFixed(2);
    }

    let IVA_total =
      data.selectIVA === 1
        ? ((subtotal * parseFloat(data.iva)) / 100).toFixed(2)
        : 0;

    let total_final = parseFloat(subtotal) + parseFloat(IVA_total);

    return total_final.toFixed(2);
  };

  const resultSubtotal = (data) => {
    let subtotal = (parseFloat(data.priceSelect) * 12).toFixed(2);

    if (radioPay === "E") {
      subtotal = (
        subtotal -
        ((subtotal * parseFloat(UserAuth.cashDiscount)) / 100).toFixed(2)
      ).toFixed(2);
    }

    return subtotal;
  };

  const resultTotalIva = (data) => {
    let subtotal = (parseFloat(data.priceSelect) * 12).toFixed(2);

    if (radioPay === "E") {
      subtotal = (
        subtotal -
        ((subtotal * parseFloat(UserAuth.cashDiscount)) / 100).toFixed(2)
      ).toFixed(2);
    }

    let IVA_total =
      data.selectIVA === 1
        ? ((subtotal * parseFloat(data.iva)) / 100).toFixed(2)
        : 0;

    return IVA_total;
  };

  const resultTotalMonthPrice = (data) => {
    let subtotal = (parseFloat(data.priceSelect) * 1).toFixed(2);

    let IVA_total =
      data.selectIVA === 1
        ? ((subtotal * parseFloat(data.iva)) / 100).toFixed(2)
        : 0;

    let total_final = parseFloat(subtotal) + parseFloat(IVA_total);

    return total_final.toFixed(2);
  };

  const resultMonthSubtotal = (data) => {
    let subtotal = (parseFloat(data.priceSelect) * 1).toFixed(2);

    return subtotal;
  };

  const resultMonthTotalIva = (data) => {
    let subtotal = (parseFloat(data.priceSelect) * 1).toFixed(2);

    let IVA_total =
      data.selectIVA === 1
        ? ((subtotal * parseFloat(data.iva)) / 100).toFixed(2)
        : 0;

    return IVA_total;
  };

  // Expresión regular para validar el formato de correo
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const submitRegister = async () => {
    setError(false);

    if (!rows) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje:
          "Debe comunicarse con el administrador del sistema para asignarles productos.",
      });

      setLoaderSave(false);
      return;
    }

    const product = rows.products.filter((filter) => filter.select === 1);

    if (product.length === 0) {
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Debe seleccionar un producto.",
      });
      setLoaderSave(false);
      return;
    }

    let productSelect = product.map((p) => ({
      ...p, // Copiar las propiedades del producto
      periodo: radioPay === "CR" ? values.monthCollection : "ANUAL", // Agregar o sobrescribir el campo 'periodo'
      payTotal: resultTotalPrice(p), // PRICE TOTAL'
      subTotal: resultSubtotal(p), // SUBTOTAL TOTAL'
      ivaTotal: resultTotalIva(p), // IVA TOTAL'
      typePay: radioPay, // FORMA DE PAGO'
      payMonthTotal: radioPay === "CR" ? resultTotalMonthPrice(p) : 0, // PRICE TOTAL PAGO MENSUAL (SOLO COBRO RECURRENTE)
      subMonthTotal: radioPay === "CR" ? resultMonthSubtotal(p) : 0, // SUBTOTAL TOTAL MENSUAL (SOLO COBRO RECURRENTE)
      ivaMonthTotal: radioPay === "CR" ? resultMonthTotalIva(p) : 0, // IVA TOTAL MENSUAL (SOLO COBRO RECURRENTE)
    }));

    if (dataClientSelect) {
      saveTransaction(productSelect, values.idClient);
      return;
    }

    const validations = {
      nameClient1: {
        value: values.nameClient1,
        message: "Agregue un nombre del cliente.",
      },
      lastNameClient1: {
        value: values.lastNameClient1,
        message: "Agregue un apellido del cliente.",
      },
      documentIdClient: {
        value: values.documentIdClient,
        message: "Agregue un documento de identidad.",
      },
      emailClient: {
        value: values.emailClient,
        message: "Agregue un correo electrónico.",
      },
      dateBirthClient: {
        value: values.dateBirthClient,
        message: "Agregue la fecha de nacimiento.",
      },
      prefix: {
        value: values.prefix,
        message: "El campo código país es obligatorio.",
      },
      phoneClient: {
        value: values.phoneClient,
        message: "Agregue un teléfono de contacto.",
      },
    };

    for (const [key, { value, message }] of Object.entries(validations)) {
      if (value.length === 0) {
        setValues((prev) => ({
          ...prev,
          [`error${key.charAt(0).toUpperCase() + key.slice(1)}`]: true,
        }));
        setAlert({
          ...alert,
          openAlert: true,
          errorAlert: "error",
          mensaje: message,
        });

        setLoaderSave(false);
        return; // Salir si hay un error
      }
    }

    if (!emailRegex.test(values.emailClient)) {
      setValues({ ...values, errorEmailClient: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: `Debe ingresar un correo electrónico válido`,
      });

      setLoaderSave(false);
      return; // Salir si hay un error
    }

    const data = {
      name1: values.nameClient1,
      name2: values.nameClient2,
      lastName1: values.lastNameClient1,
      lastName2: values.lastNameClient2,
      allNames: `${values.nameClient1} ${values.nameClient2} ${values.lastNameClient1} ${values.lastNameClient2}`,
      email: values.emailClient,
      documentId: values.documentIdClient,
      typeDocument: radioDocument,
      datebirth: values.dateBirthClient,
      prefix: JSON.stringify(values.prefix),
      phone: values.phoneClient,
      productsId: product[0].id,
      userId: UserAuth.id,
      companyId: UserAuth.companyId,
      ...(rowsItem.length > 0 && { dependents: JSON.stringify(rowsItem) }), // Solo agregar si hay dependientes
    };

    try {
      const response = await axios.post(`${urlServices}clients`, data, {
        headers: {
          Authorization: "Bearer " + keyAuthorization,
        },
      });

      if (response.status === 200) {
        await saveTransaction(productSelect, response.data.clients.id);
        /*  window.scrollTo({ top: 0, behavior: "smooth" });
        setSuccess(true);
        setLoaderSave(false);*/
      }
    } catch (error) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }

      setLoaderSave(false);
    }
  };

  const saveTransaction = async (product, clientId) => {
    const data = {
      clientsId: clientId,
      productsId: product[0].id,
      productsJson: JSON.stringify(product),
      userId: UserAuth.id,
      companyId: UserAuth.companyId,
      commissionPercentageUser: parseFloat(UserAuth.commissionPercentage),
      ...(rowsItem.length > 0 && { dependentsJson: JSON.stringify(rowsItem) }), // Solo agregar si hay dependientes
      discountPercentage: UserAuth.cashDiscount,
    };

    if (radioPay === "CR") {
      // Sumar meses
      /*const dateStart = Moment().format("YYYY-MM-DD");
      const endDate = Moment(dateStart)
        .add(parseInt(values.monthCollection), "months")
        .toDate();*/

      data.nextRecurringPayment = Moment().format("YYYY-MM-DD");
      data.endRecurringPayment = null;
    }

    try {
      const response = await axios.post(
        `${urlServices}clients-transaction/${
          radioPay === "TC"
            ? "create"
            : radioPay === "E"
            ? "create-cash"
            : "create-recurring-collection"
        }`,
        data,
        {
          headers: {
            Authorization: "Bearer " + keyAuthorization,
          },
        }
      );

      if (response.status === 200) {
        window.scrollTo({ top: 0, behavior: "smooth" });
        setSuccess(true);
        setLoaderSave(false);
      }
    } catch (error) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (error.response?.status === 401) {
        setMensageSystem("La sesión ha expirado, vuelva a iniciar sesión ...");
        setError(true);
        setTimeout(() => {
          localStorage.clear();
          setReturnLogin(true);
        }, 4000);
      } else if (error.response?.status === 500) {
        setMensageSystem("Error en la consulta con el servidor.");
        setError(true);
      } else {
        console.error("Error en la solicitud:", error);
        setMensageSystem("Error al realizar la solicitud.");
        setError(true);
      }

      setLoaderSave(false);
    }
  };

  const handleAdd = () => {
    if (values.nameDependent1.length === 0) {
      setValues({ ...values, errorNameDependent1: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue el nombre.",
      });
    } else if (values.lastNameDependent1.length === 0) {
      setValues({ ...values, errorLastNameDependent1: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue el apellido.",
      });
    } else if (values.documentIdDependent.length === 0) {
      setValues({ ...values, errorDocumentIdDependent: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue una identificación.",
      });
    } else if (values.dateBirthDependent.length === 0) {
      setValues({ ...values, errorDateBirthDependent: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Agregue la fecha de nacimiento.",
      });
    } else if (values.typePerson.length === 0) {
      setValues({ ...values, errorTypePerson: true });
      setAlert({
        ...alert,
        openAlert: true,
        errorAlert: "error",
        mensaje: "Seleccione un tipo de persona.",
      });
    } else {
      setrowsItem([
        ...rowsItem,
        {
          id: (Math.floor(Math.random() * 900000) + 100000).toString(),
          nameDependent1: values.nameDependent1,
          nameDependent2: values.nameDependent2,
          lastNameDependent1: values.lastNameDependent1,
          lastNameDependent2: values.lastNameDependent2,
          allNames: `${values.nameDependent1} ${values.nameDependent2} ${values.lastNameDependent1} ${values.lastNameDependent2}`,
          documentIdDependent: values.documentIdDependent,
          dateBirthDependent: values.dateBirthDependent,
          typePersonId: values.typePerson,
          typePersonName: values.typePersonName,
          status: 1,
        },
      ]);

      setValues({
        ...values,
        nameDependent1: "",
        nameDependent2: "",
        lastNameDependent1: "",
        lastNameDependent2: "",
        documentIdDependent: "",
        dateBirthDependent: "",
        typePerson: "",
        typePersonName: "",
        typePersonData: "",
      });

      setDateBirthDependent();
      setRows({
        ...rows,
        products: resetSelect(rows),
      });
      setRadioPrices({});
    }
  };

  const handleRemoveClick = (i) => {
    const list = [...rowsItem];
    list.splice(i, 1);
    setrowsItem(list);
    setRows({
      ...rows,
      products: resetSelect(rows),
    });
    setRadioPrices({});
  };

  const handleAddPersonClick = (data) => () => {
    setValues({
      ...values,
      nameDependent1: "",
      nameDependent2: "",
      lastNameDependent1: "",
      lastNameDependent2: "",
      documentIdDependent: "",
      dateBirthDependent: "",
      typePerson: "",
      typePersonName: "",
      typePersonData: "",
    });

    setAddPerson(data);
    setrowsItem([]);
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlert({ openAlert: false });
  };

  const changePrefix = (data) => {
    setValues({
      ...values,
      prefix: data !== null ? data : null,
      prefixData: data !== null ? data : null,
      errorPrefix: false,
    });

    setAlert({
      ...alert,
      openAlert: false,
    });
  };

  const newClient = () => {
    const initialValues = {
      nameClient1: "",
      nameClient2: "",
      lastNameClient1: "",
      lastNameClient2: "",
      emailClient: "",
      documentIdClient: "",
      dateBirthClient: "",
      phoneClient: "",
      nameDependent1: "",
      nameDependent2: "",
      lastNameDependent1: "",
      lastNameDependent2: "",
      documentIdDependent: "",
      dateBirthDependent: "",
      typePerson: "",
      typePersonName: "",
      typePersonData: "",
      prefix: "",
      prefixData: null,
    };

    setValues({ ...values, ...initialValues });
    setRows({
      ...rows,
      products: resetSelect(rows),
    });
    setRadioPay("TC");
    setRadioDocument("CI");
    setRadioPrices({});
    setProductInfo(null);
    setrowsItem([]);
    setAddPerson(false);
    setDateBirthClient();
    setDateBirthDependent();
    setSuccess(false);
    setDataClientSelect(false);
  };

  const resetSelect = (items) => {
    return items.products.map((item) => ({
      ...item,
      select: 0,
      priceSelect: null,
    }));
  };

  if (clientsList) {
    localStorage.setItem("controllerRouter", "/customers/clients");
    return <Redirect to="/customers/clients" />;
  }

  const handleSelectClient = (data) => {
    setValues({
      ...values,
      idClient: data.row.id,
      nameClient1: data.row.name1,
      nameClient2: data.row.name2,
      lastNameClient1: data.row.lastName1,
      lastNameClient2: data.row.lastName2,
      emailClient: data.row.email,
      documentIdClient: data.row.documentId,
      dateBirthClient: data.row.datebirth,
      prefix: data.row.prefix,
      prefixData: data.row.prefix,
      phoneClient: data.row.phone,
    });

    let dataDepentents = parseJsonArray(data.row.dependents);

    dataDepentents = dataDepentents.filter((val) => val.status === 1);

    setrowsItem([...rowsItem, ...dataDepentents]);

    setAddPerson(true);

    setDateBirthClient(dayjs(data.row.datebirth));
    setDataClientSelect(true);
  };

  // Función para parsear cadenas JSON y asegurar que sean arrays
  const parseJsonArray = (jsonString) => {
    try {
      const parsed = JSON.parse(jsonString);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      console.error("Error parsing JSON:", error);
      return [];
    }
  };

  const handleCloseRegister = () => () => {
    setValues({
      ...values,
      nameClient1: "",
      nameClient2: "",
      lastNameClient1: "",
      lastNameClient2: "",
      emailClient: "",
      documentIdClient: "",
      dateBirthClient: "",
      phoneClient: "",
      prefix: "",
      prefixData: null,
    });

    setrowsItem([]);
    setAddPerson(false);
    setDateBirthClient();
    setDataClientSelect(false);
  };

  const handleRadioChange = (event) => {
    setRadioExample(event.target.value);
  };

  /*const handleChangeMonthCollection = (event) => {
    setValues((prevValues) => ({
      ...prevValues,
      monthCollection: event.target.value,
    }));
  };*/

  const handleRadioPayChange = (event) => {
    if (event.target.value === "E") {
      if (!UserAuth.cashDiscount || UserAuth.cashDiscount === "") {
        setViewCashDiscount(true);
      }
    } else {
      setViewCashDiscount(false);
    }

    setRadioPay(event.target.value);

    /* setValues((prevValues) => ({
      ...prevValues,
      monthCollection: "",
    }));*/
  };

  /*const SelectProduct = (data) => () => {
    const { name } = data; // Destructurar para obtener name

    const updatedProducts = rows.products.map((product) => {
      return {
        ...product,
        select:
          product.select === 1 ? 0 : name === product.name ? 1 : product.select, // Cambiar selección
      };
    });

    setProductInfo(data);

    setRows({ ...rows, products: updatedProducts });
  };*/

  const handleRadioDocument = (event) => {
    setValues({ ...values, documentIdClient: "" });
    setRadioDocument(event.target.value);
  };

  function validarCedula(cedula) {
    // Verifica que la cédula tenga 10 dígitos
    if (cedula.length !== 10) return false;

    // Coeficientes para el cálculo del dígito verificador
    const coeficientes = [2, 1, 2, 1, 2, 1, 2, 1, 2];
    let suma = 0;

    // Recorremos los primeros 9 dígitos
    for (let i = 0; i < 9; i++) {
      let digito = parseInt(cedula.charAt(i), 10);
      let producto = digito * coeficientes[i];

      // Si el producto es mayor a 9, sumamos los dígitos
      if (producto > 9) producto = producto - 9;

      suma += producto;
    }

    // Calculamos el dígito verificador
    const digitoVerificadorCalculado = (10 - (suma % 10)) % 10;
    const digitoVerificadorCedula = parseInt(cedula.charAt(9), 10);

    // Comparamos el dígito verificador calculado con el de la cédula
    return digitoVerificadorCalculado === digitoVerificadorCedula;
  }

  function validarRUC(ruc) {
    // Verifica que el RUC tenga 13 dígitos
    if (ruc.length !== 13 || isNaN(ruc)) return false;

    // Los coeficientes para empresas privadas o instituciones públicas
    const tercerDigito = parseInt(ruc.charAt(2), 10);
    const coeficientes =
      tercerDigito === 9
        ? [4, 3, 2, 7, 6, 5, 4, 3, 2] // Empresas privadas
        : [3, 2, 7, 6, 5, 4, 3, 2]; // Instituciones públicas

    let suma = 0;

    // Multiplicamos cada dígito por el coeficiente correspondiente
    for (let i = 0; i < 9; i++) {
      let digito = parseInt(ruc.charAt(i), 10);
      suma += digito * coeficientes[i];
    }

    // El dígito verificador es el residuo de la suma dividida entre 11
    const digitoVerificador = (11 - (suma % 11)) % 11;

    // El dígito verificador debe coincidir con el noveno dígito del RUC
    return digitoVerificador === parseInt(ruc.charAt(9), 10);
  }

  const handleBlur = () => {
    let isValid = true;

    if (radioDocument === "CI") {
      isValid = validarCedula(values.documentIdClient);
    } else if (radioDocument === "RUC") {
      isValid = validarRUC(values.documentIdClient);
    }

    setValues({
      ...values,
      errorDocumentIdClient: !isValid,
    });
  };

  const handleRadioPriceChange = (data, i0) => (event) => {
    // Actualiza solo el índice de selección para el producto específico
    setRadioPrices({
      [data.id]: i0, // Solo se guarda la última selección para este producto
    });

    // Actualizamos la selección de los productos
    const updatedProducts = rows.products.map((product) => {
      // Si el producto actual es el que se está seleccionando (con el mismo dataId)
      if (product.id === data.id) {
        // Si el índice del precio seleccionado es el que corresponde a este producto, marcarlo como seleccionado
        return {
          ...product,
          select: 1, // Si i0 es el índice actual, marcamos como seleccionado
          nameSelect: product.prices[i0].name, // nombre seleccionado
          priceSelect: product.prices[i0].price, // precio seleccionado
        };
      } else {
        // Si no es el producto seleccionado, mantener su estado de selección anterior (0 o 1)
        return {
          ...product,
          select: 0, // Desmarcar los demás productos
          nameSelect: null,
          priceSelect: null,
        };
      }
    });

    setProductInfo({
      price: data.prices[i0].price,
      iva: data.iva,
      selectIVA: data.selectIVA,
    });

    // Actualiza el estado de los productos en 'rows'
    setRows({ ...rows, products: updatedProducts });

    setAlert((prevAlert) => ({
      ...prevAlert,
      openAlert: false,
    }));
    /*console.log("Producto seleccionado:", dataId);
    console.log("Índice de precio seleccionado:", i0);*/
  };

  const handleAddRegister = () => () => {
    setOpenAddRegister(true);
  };

  const handleCloseAddRegister = () => {
    setOpenAddRegister(false);
  };

  if (returnLogin) {
    return <Redirect to="/" />;
  }

  return (
    <Fragment>
      <Grid
        container
        spacing={1}
        className={classes.containerProfile}
        sx={{ mt: 1 }}
      >
        <Grid item xs={12} sm={12}>
          {error && <Alert severity="error">{mensageSystem}</Alert>}
        </Grid>
        <Grid item xs={12} sm={12}>
          <div className={classes.cardTitleBlack} style={{ margin: "6px 0" }}>
            <Add className={classes.iconFilter} /> Registrar nueva solicitud{" "}
            <ButtonExit
              startIcon={<Close />}
              onClick={() => setClientsList(true)}
              style={{ float: "right" }}
            >
              SALIR DEL REGISTRO
            </ButtonExit>
          </div>
        </Grid>
        {success ? (
          <>
            <Grid
              item
              xs={12}
              sm={12}
              sx={{
                margin: "2px 0 10px 0",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={successImg}
                alt="type"
                style={{ width: 200, marginBottom: 20 }}
              />
              <Alert severity="success" icon={false} sx={{ fontSize: 24 }}>
                Registro realizado con éxito
              </Alert>
            </Grid>
            <Grid item xs={12} style={{ paddingTop: 10 }}>
              <center>
                <ButtonStyle0
                  startIcon={<KeyboardBackspace />}
                  onClick={newClient}
                >
                  Nuevo registro
                </ButtonStyle0>
              </center>
            </Grid>
          </>
        ) : (
          <>
            <Grid item xs={12} sm={12}>
              <PermIdentityOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 40 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 22,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Datos del cliente
              </span>
              <Button
                style={{ marginLeft: 12 }}
                onClick={
                  dataClientSelect ? handleCloseRegister() : handleAddRegister()
                }
                startIcon={dataClientSelect ? <Close /> : <AddCircle />}
                variant="contained"
                size="small"
                color={dataClientSelect ? "warning" : "primary"}
              >
                {dataClientSelect
                  ? "Quitar cliente registrado"
                  : "Agregar cliente registrado"}
              </Button>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="nameClient1"
                value={values.nameClient1}
                error={values.errorNameClient1}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  // Permitir solo letras, espacios, ñ y tildes
                  const filteredValue = inputValue.replace(
                    /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                    ""
                  );
                  handleChange("nameClient1", filteredValue);
                }}
                fullWidth
                required
                label="Primer nombre"
                margin="dense"
                autoComplete="off"
                size="small"
                disabled={dataClientSelect}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="nameClient2"
                value={values.nameClient2}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  // Permitir solo letras, espacios, ñ y tildes
                  const filteredValue = inputValue.replace(
                    /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                    ""
                  );
                  handleChange("nameClient2", filteredValue);
                }}
                fullWidth
                label="Segundo nombre"
                margin="dense"
                autoComplete="off"
                size="small"
                disabled={dataClientSelect}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="lastNameClient1"
                value={values.lastNameClient1}
                error={values.errorLastNameClient1}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  // Permitir solo letras, espacios, ñ y tildes
                  const filteredValue = inputValue.replace(
                    /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                    ""
                  );
                  handleChange("lastNameClient1", filteredValue);
                }}
                fullWidth
                required
                label="Primer apellido"
                margin="dense"
                autoComplete="off"
                size="small"
                disabled={dataClientSelect}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="lastNameClient2"
                value={values.lastNameClient2}
                onChange={(event) => {
                  const inputValue = event.target.value;
                  // Permitir solo letras, espacios, ñ y tildes
                  const filteredValue = inputValue.replace(
                    /[^a-zA-ZáéíóúÁÉÍÓÚñÑ\s]/g,
                    ""
                  );
                  handleChange("lastNameClient2", filteredValue);
                }}
                fullWidth
                label="Segundo apellido"
                margin="dense"
                autoComplete="off"
                size="small"
                disabled={dataClientSelect}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="emailClient"
                value={values.emailClient}
                error={values.errorEmailClient}
                onChange={(event) =>
                  handleChange("emailClient", event.target.value)
                }
                fullWidth
                required
                label="Correo electrónico"
                margin="dense"
                autoComplete="off"
                size="small"
                disabled={dataClientSelect}
                InputProps={{
                  endAdornment: (
                    <MailOutline
                      fontSize="small"
                      className={classes.iconInput}
                      position="end"
                    ></MailOutline>
                  ),
                }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    name="dateBirthClient"
                    label="Fecha de nacimiento"
                    value={dateBirthClient}
                    onChange={(newValue) => handleDateBirthChange(newValue)}
                    format="DD/MM/YYYY"
                    sx={{
                      "& .MuiButtonBase-root": {
                        color: "#333",
                      },
                      width: "100%",
                      background: "#FFFFFF",
                    }}
                    slotProps={{
                      textField: {
                        // helperText: "DD/MM/YYYY",
                        error: values.errorDateBirthClient,
                        required: true,
                        size: "small",
                      },
                    }}
                    disabled={dataClientSelect}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  sx={{ color: blackColor }}
                >
                  Tipo de documento:
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="row-radio-buttons-group"
                  value={radioDocument}
                  onChange={handleRadioDocument}
                >
                  <FormControlLabel
                    value="CI"
                    control={<Radio disabled={dataClientSelect} />}
                    label="Cédula"
                    sx={{ color: blackColor }}
                  />
                  <FormControlLabel
                    value="RUC"
                    control={<Radio disabled={dataClientSelect} />}
                    label="RUC"
                    sx={{ color: blackColor }}
                  />
                  <FormControlLabel
                    value="PPN"
                    control={<Radio disabled={dataClientSelect} />}
                    label="Pasaporte"
                    sx={{ color: blackColor }}
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                name="documentIdClient"
                value={values.documentIdClient}
                error={values.errorDocumentIdClient}
                onChange={(event) => {
                  let newValue = event.target.value;

                  // Si el tipo es número, limitamos la cantidad de dígitos
                  if (radioDocument === "CI") {
                    newValue = newValue.replace(/[^0-9]/g, "").slice(0, 10);
                  } else if (radioDocument === "RUC") {
                    newValue = newValue.replace(/[^0-9]/g, "").slice(0, 13);
                  } else {
                    newValue = newValue.slice(0, 13);
                  }

                  handleChange("documentIdClient", newValue);
                }}
                fullWidth
                required
                label="Nro. de documento"
                margin="dense"
                variant="outlined"
                autoComplete="off"
                type="text"
                size="small"
                disabled={dataClientSelect}
                onBlur={handleBlur} // Llamamos a la validación cuando el campo pierde el foco
              />
              {values.errorDocumentIdClient && (
                <Alert severity="error">Documento ingresado no válido.</Alert>
              )}
            </Grid>
            <Grid item xs={3} md={3}>
              <LoadPrefixes
                value={values.prefixData}
                refresh={changePrefix}
                error={values.errorPrefix}
                hide={dataClientSelect}
              />
            </Grid>
            <Grid item xs={3} md={3}>
              <TextField
                id="outlined-basic"
                label="Teléfono móvil"
                variant="outlined"
                onChange={(e) => {
                  const value = e.target.value;

                  // Permitir el valor vacío o un número que no comience con '0'
                  if (value === "" || (value.length > 0 && value[0] !== "0")) {
                    handleChange("phoneClient", e.target.value); // Actualiza el valor
                  }
                }}
                inputProps={{
                  style: {
                    textAlign: "left",
                  },
                  maxLength: 9,
                }}
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9]/g, "");
                }}
                value={values.phoneClient}
                autoComplete="off"
                margin="dense"
                size="small"
                error={values.errorPhoneClient}
                fullWidth
                placeholder="958732826"
                disabled={dataClientSelect}
                required
                // helperText="Sin cero (0) en el inicio."
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              sx={{ mt: 4, display: dataClientSelect ? "none" : "block" }}
            >
              <b style={{ color: "#000" }}>¿Desea agregar familiares?</b>
              <Button
                style={{ marginLeft: 12 }}
                onClick={handleAddPersonClick(!addPerson)}
                startIcon={addPerson ? <Close /> : <AddCircle />}
                variant="contained"
                size="small"
                color={addPerson ? "error" : "primary"}
              >
                {addPerson ? "No agregar" : "Agregar"}
              </Button>
            </Grid>
            {addPerson && (
              <>
                <Grid item xs={12} sm={12} sx={{ marginTop: 3 }}>
                  <PermIdentityOutlined className={classes.iconFilter} />{" "}
                  <b style={{ color: "#000" }}>Datos de familiares</b>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <TextField
                    name="nameDependent1"
                    value={values.nameDependent1}
                    error={values.errorNameDependent1}
                    onChange={(event) =>
                      handleChange("nameDependent1", event.target.value)
                    }
                    fullWidth
                    required
                    label="Primer nombre"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <TextField
                    name="nameDependent2"
                    value={values.nameDependent2}
                    onChange={(event) =>
                      handleChange("nameDependent2", event.target.value)
                    }
                    fullWidth
                    label="Segundo nombre"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <TextField
                    name="lastNameDependent1"
                    value={values.lastNameDependent1}
                    error={values.errorLastNameDependent1}
                    onChange={(event) =>
                      handleChange("lastNameDependent1", event.target.value)
                    }
                    fullWidth
                    required
                    label="Primer apellido"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <TextField
                    name="lastNameDependent2"
                    value={values.lastNameDependent2}
                    onChange={(event) =>
                      handleChange("lastNameDependent2", event.target.value)
                    }
                    fullWidth
                    label="Segundo apellido"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <TextField
                    name="documentIdDependent"
                    value={values.documentIdDependent}
                    error={values.errorDocumentIdDependent}
                    onChange={(event) =>
                      handleChange("documentIdDependent", event.target.value)
                    }
                    fullWidth
                    required
                    label="Nro. de documento"
                    margin="dense"
                    autoComplete="off"
                    variant="outlined"
                    size="small"
                    type="number"
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DemoContainer components={["DatePicker"]}>
                      <DatePicker
                        name="dateBirthDependent"
                        label="Fecha de nacimiento"
                        value={dateBirthDependent}
                        onChange={(newValue) =>
                          handleDateBirthDependentChange(newValue)
                        }
                        format="DD/MM/YYYY"
                        sx={{
                          "& .MuiButtonBase-root": {
                            color: "#333",
                          },
                          width: "100%",
                          background: "#FFFFFF",
                        }}
                        slotProps={{
                          textField: {
                            // helperText: "DD/MM/YYYY",
                            error: values.errorDateBirthDependent,
                            required: true,
                            size: "small",
                          },
                        }}
                      />
                    </DemoContainer>
                  </LocalizationProvider>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <LoadTypeDependents
                    value={values.typePersonData}
                    refresh={handleChangeTypePerson}
                    error={values.errorTypePerson}
                  />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  sx={{ display: dataClientSelect ? "none" : "block" }}
                >
                  <Button
                    style={{ marginTop: 12 }}
                    onClick={handleAdd}
                    startIcon={<AddCircle />}
                    variant="contained"
                    size="small"
                  >
                    Agregar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={12}>
                  {rowsItem.length > 0 ? (
                    <Table
                      className={classes.table}
                      size="small"
                      aria-label="a dense table"
                      sx={{ mt: 5 }}
                    >
                      <TableBody>
                        <TableCell component="th" scope="row">
                          <b>Nombres y apellidos</b>{" "}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <b>Documento</b>{" "}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <b>Fecha de nacimiento</b>{" "}
                        </TableCell>
                        <TableCell component="th" scope="row">
                          <b>Tipo</b>{" "}
                        </TableCell>
                        <TableCell component="th" scope="row"></TableCell>
                        {rowsItem.map((row1, i1) => {
                          return (
                            <StyledTableRow key={i1}>
                              <TableCell
                                // align="center"
                                component="td"
                                scope="row"
                              >
                                {row1.allNames}
                              </TableCell>
                              <TableCell
                                // align="center"
                                component="td"
                                scope="row"
                              >
                                {row1.documentIdDependent}
                              </TableCell>
                              <TableCell
                                // align="center"
                                component="td"
                                scope="row"
                              >
                                {row1.dateBirthDependent}
                              </TableCell>
                              <TableCell
                                // align="center"
                                component="td"
                                scope="row"
                              >
                                {row1.typePersonName}
                              </TableCell>
                              <TableCell
                                align="center"
                                component="td"
                                scope="row"
                              >
                                <Delete
                                  style={{
                                    cursor: "pointer",
                                    float: "right",
                                  }}
                                  onClick={() => handleRemoveClick(i1)}
                                />
                              </TableCell>
                            </StyledTableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  ) : (
                    <center>
                      <div style={{ margin: "60px 0", fontWeight: "bold" }}>
                        Sin datos de familiares
                      </div>
                    </center>
                  )}
                </Grid>
              </>
            )}
            <Grid item xs={12} sm={12} sx={{ margin: "20px 0 5px 0" }}>
              <QrCodeOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 40 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 22,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Seleccionar un producto
              </span>
            </Grid>
            {loader ? (
              <Grid item xs={12} sm={12}>
                <center>
                  <img
                    alt="loaderGif"
                    src={loaderGif}
                    style={{ width: 60, margin: "5% 0" }}
                  />
                </center>
              </Grid>
            ) : rows ? (
              <>
                <Grid item xs={12} sm={12}>
                  <Button
                    size="small"
                    sx={{
                      float: "right",
                      color: blackColor,
                      fontSize: 12,
                      textTransform: "capitalize",
                    }}
                    onClick={() => setViewDetailsItems(!viewDetailsItems)}
                    variant="outlined"
                  >
                    {viewDetailsItems
                      ? `Ver detalles del producto`
                      : `Ocultar detalles`}
                  </Button>
                </Grid>
                {rows.products
                  .sort((a, b) => a.order - b.order) // Ordena de menor a mayor
                  .map((data, i) => (
                    <Grid item xs={12} sm={4} key={i}>
                      <Card
                        sx={{
                          maxWidth: 345,
                          background:
                            data.select && data.select === 1
                              ? "honeydew"
                              : "#f9f9f7",
                        }}
                        variant="outlined"
                      >
                        <CardMedia
                          sx={{ height: 50 }}
                          image={productImg}
                          title={`product${i}`}
                        />
                        <CardContent>
                          <Typography gutterBottom variant="h6" component="div">
                            {data.name}
                          </Typography>
                          <Typography
                            sx={{
                              fontSize: 10,
                              float: "right",
                              fontWeight: 500,
                            }}
                            component="div"
                          >
                            Precios sin IVA
                          </Typography>
                          <br></br>
                          <Typography gutterBottom variant="h6" component="div">
                            {data.prices.map((data0, i0) => (
                              <RadioGroup
                                key={i0} // Clave única para cada RadioGroup
                                aria-labelledby="demo-radios"
                                name={`priceSelect-${i}`} // Nombre único por producto
                                value={radioPrices[data.id] ?? ""} // Selección del radio actual
                                onChange={handleRadioPriceChange(data, i0)} // Actualiza el índice seleccionado
                              >
                                <FormControlLabel
                                  value={i0} // El valor único para cada radio
                                  control={
                                    <Radio
                                      disabled={
                                        rowsItem.length === 0
                                          ? i0 === 0
                                            ? false
                                            : true
                                          : rowsItem.length === 1
                                          ? i0 === 1
                                            ? false
                                            : true
                                          : rowsItem.length > 1
                                          ? i0 === 2
                                            ? false
                                            : true
                                          : true
                                      }
                                    />
                                  }
                                  sx={{ color: blackColor }}
                                  label={
                                    <Grid
                                      container
                                      spacing={1}
                                      sx={{ fontSize: 14, width: 240 }}
                                    >
                                      <Grid item xs={8} sm={8}>
                                        {data0.name} {/* Nombre del producto */}
                                      </Grid>
                                      <Grid
                                        item
                                        xs={4}
                                        sm={4}
                                        sx={{
                                          textAlign: "right",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        ${data0.price}
                                      </Grid>
                                    </Grid>
                                  }
                                />
                              </RadioGroup>
                            ))}
                          </Typography>
                          <Table
                            size="small"
                            aria-label="a dense table"
                            sx={{
                              width: "100%",
                              display: viewDetailsItems ? "none" : "block",
                            }}
                          >
                            <TableBody>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  fontSize: 11,
                                  textAlign: "center",
                                  padding: 0,
                                }}
                              >
                                <b>Especialidad</b>
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{ fontSize: 11, textAlign: "center" }}
                              >
                                <b>Procedimiento</b>
                              </TableCell>
                              <TableCell
                                component="th"
                                scope="row"
                                sx={{
                                  fontSize: 11,
                                  textAlign: "center",
                                  padding: 0,
                                }}
                              >
                                <b>Beneficio</b>
                              </TableCell>
                              {data.itemsProduct
                                .sort((a, b) => a.nOrder - b.nOrder) // Ordena de menor a mayor
                                .map((dataItems, i1) => (
                                  <StyledTableRow key={i1}>
                                    <TableCell
                                      // align="center"
                                      sx={{
                                        fontSize: 10,
                                        fontWeight: "bold",
                                        padding: 0,
                                      }}
                                    >
                                      {dataItems.pecialty}
                                    </TableCell>
                                    <TableCell
                                      // align="center"
                                      sx={{ fontSize: 10 }}
                                    >
                                      {dataItems.procedure}
                                    </TableCell>
                                    <TableCell
                                      // align="center"
                                      sx={{ fontSize: 10, padding: 0 }}
                                    >
                                      {dataItems.coverage}
                                    </TableCell>
                                  </StyledTableRow>
                                ))}
                            </TableBody>
                          </Table>
                        </CardContent>
                        <CardActions>
                          <Button
                            size="small"
                            color={
                              data.select && data.select === 1
                                ? "success"
                                : "primary"
                            }
                            // onClick={SelectProduct(data)}
                          >
                            {data.select && data.select === 1 ? (
                              <>
                                <CheckCircleOutline sx={{ ml: 10 }} />{" "}
                                Seleccionado
                              </>
                            ) : (
                              "Seleccionar una opción"
                            )}
                          </Button>
                        </CardActions>
                      </Card>
                    </Grid>
                  ))}
              </>
            ) : (
              <Grid item xs={12} sm={12}>
                {nullProducts && (
                  <Alert severity="warning">
                    El administrador debe registrar los productos.
                  </Alert>
                )}
              </Grid>
            )}
            <Grid item xs={12} sm={12} sx={{ margin: "20px 0 5px 0" }}>
              <AddCardOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 40 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 22,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Forma de pago
              </span>
            </Grid>
            <Grid item xs={12} md={12}>
              <Alert
                severity="error"
                sx={{
                  display: viewCashDiscount ? "flex" : "none",
                }}
              >
                Debe ir al módulo de <b>DATOS DE LA EMPRESA</b> para registrar
                el porcentaje de descuento por pago al contado.
              </Alert>
              <RadioGroup
                aria-labelledby="demo-error-radios"
                name="quiz"
                value={radioPay}
                onChange={handleRadioPayChange}
                sx={{ fontSize: 12 }}
                row
              >
                <FormControlLabel
                  control={<Radio />}
                  value="TC"
                  label="TARJETA DE CRÉDITO"
                  sx={{ color: blackColor }}
                />
                <FormControlLabel
                  control={<Radio />}
                  value="E"
                  label="PAGO AL CONTADO"
                  sx={{ color: blackColor }}
                />
                <FormControlLabel
                  value="CR"
                  control={<Radio />}
                  label="COBRO RECURRENTE"
                  sx={{ color: blackColor }}
                />
                {/* <FormControlLabel
                  value="ANUAL"
                  control={<Radio />}
                  label="ANUAL"
                  sx={{ color: blackColor }}
                />*/}
              </RadioGroup>
              <Grid container>
                {/*radioPay === "CR" && (
                  <>
                    <Grid item xs={12} sm={12} sx={{ mt: 1 }}>
                      <div
                        className={classes.cardTitleBlack}
                        style={{ margin: "6px 0", fontSize: 14 }}
                      >
                        Seleccione el número de meses a cobrar:
                      </div>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <FormControl sx={{ width: "100%" }} size="small">
                        <Select
                          labelId="demo-select-small-label"
                          id="demo-select-small"
                          value={values.monthCollection}
                          //  label="Age"
                          onChange={handleChangeMonthCollection}
                        >
                          <MenuItem value="">
                            <em>Seleccione...</em>
                          </MenuItem>
                          <MenuItem value={1}>1 mes</MenuItem>
                          <MenuItem value={3}>3 meses</MenuItem>
                          <MenuItem value={6}>6 meses</MenuItem>
                          <MenuItem value={12}>12 meses</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  </>
                )*/}
                {radioPay === "E" && !viewCashDiscount && (
                  <Grid item xs={12} sm={6}>
                    <Alert severity="info">
                      Se aplicará un descuento del{" "}
                      <b>{UserAuth.cashDiscount}%</b> al plan seleccionado.
                    </Alert>
                  </Grid>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} sx={{ margin: "20px 0 5px 0" }}>
              <CalendarMonthOutlined
                className={classes.iconFilter}
                sx={{ fontSize: 40 }}
              />{" "}
              <span
                style={{
                  color: "#202C59",
                  fontSize: 22,
                  fontWeight: 400,
                  verticalAlign: "middle",
                }}
              >
                Visualización PVP
              </span>
            </Grid>
            <Grid item xs={12} md={8}>
              <RadioGroup
                aria-labelledby="demo-error-radios"
                name="quiz"
                value={radioExample}
                onChange={handleRadioChange}
                row
              >
                <FormControlLabel
                  value="MENSUAL"
                  control={<Radio />}
                  label="MENSUAL"
                  sx={{ color: blackColor }}
                />
                {radioPay !== "CR" && (
                  <FormControlLabel
                    value="ANUAL"
                    control={<Radio />}
                    label="ANUAL"
                    sx={{ color: blackColor }}
                  />
                )}

                {/*<FormControlLabel
                  value="ANUAL"
                  control={<Radio />}
                  label={
                    radioPay === "CR"
                      ? values.monthCollection >= 1
                        ? `TOTAL POR ${values.monthCollection} ${
                            values.monthCollection === 1 ? "MES" : "MESES"
                          } A COBRAR`
                        : "ANUAL"
                      : "ANUAL"
                  }
                  sx={{ color: blackColor }}
                />*/}
              </RadioGroup>
            </Grid>
            {productInfo && !viewCashDiscount && (
              <Grid item xs={12} md={12}>
                <Grid
                  container
                  sx={{
                    background: "papayawhip",
                    padding: "8px 15px",
                    borderTopLeftRadius: 5,
                    borderTopLeftRadius: 5,
                    color: blackColor,
                  }}
                >
                  <Grid
                    item
                    xs={3}
                    md={3}
                    sx={{
                      display: radioPay === "E" ? "block" : "none",
                    }}
                  >
                    <Typography
                      gutterBottom
                      sx={{
                        textAlign: "center",
                        fontWeight: 400,
                        fontSize: 14,
                      }}
                    >
                      DESCUENTO AL CONTADO:{" "}
                      <b>
                        {UserAuth.cashDiscount ? UserAuth.cashDiscount : 0}%
                      </b>
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={
                      productInfo.selectIVA === 0 ? 4 : radioPay === "E" ? 3 : 4
                    }
                    md={
                      productInfo.selectIVA === 0 ? 4 : radioPay === "E" ? 3 : 4
                    }
                    sx={{ textAlign: "center", fontWeight: 400, fontSize: 14 }}
                  >
                    SUBTOTAL: $
                    <b>
                      {radioPay !== "E"
                        ? (
                            parseFloat(productInfo.price) *
                            (radioExample === "MENSUAL"
                              ? 1
                              : radioPay === "CR"
                              ? values.monthCollection >= 1
                                ? parseFloat(values.monthCollection)
                                : 12
                              : 12)
                          ).toFixed(2)
                        : (
                            (
                              parseFloat(productInfo.price) *
                              (radioExample === "MENSUAL"
                                ? 1
                                : radioPay === "CR"
                                ? values.monthCollection >= 1
                                  ? parseFloat(values.monthCollection)
                                  : 12
                                : 12)
                            ).toFixed(2) -
                            (
                              ((
                                parseFloat(productInfo.price) *
                                (radioExample === "MENSUAL"
                                  ? 1
                                  : radioPay === "CR"
                                  ? values.monthCollection >= 1
                                    ? parseFloat(values.monthCollection)
                                    : 12
                                  : 12)
                              ).toFixed(2) *
                                parseFloat(UserAuth.cashDiscount)) /
                              100
                            ).toFixed(2)
                          ).toFixed(2)}
                    </b>
                  </Grid>
                  <Grid
                    item
                    xs={
                      productInfo.selectIVA === 0 ? 6 : radioPay === "E" ? 3 : 4
                    }
                    md={
                      productInfo.selectIVA === 0 ? 6 : radioPay === "E" ? 3 : 4
                    }
                    sx={{
                      textAlign: "center",
                      fontWeight: 400,
                      fontSize: 14,
                      display: productInfo.selectIVA === 1 ? "block" : "none",
                    }}
                  >
                    IVA: $
                    <b>
                      {radioPay !== "E"
                        ? (
                            (
                              parseFloat(productInfo.price) *
                              (parseFloat(productInfo.iva) / 100)
                            ).toFixed(2) *
                            (radioExample === "MENSUAL"
                              ? 1
                              : radioPay === "CR"
                              ? values.monthCollection >= 1
                                ? parseFloat(values.monthCollection)
                                : 12
                              : 12)
                          ).toFixed(2)
                        : (
                            ((
                              parseFloat(productInfo.price) *
                              (radioExample === "MENSUAL" ? 1 : 12)
                            ).toFixed(2) -
                              (
                                ((
                                  parseFloat(productInfo.price) *
                                  (radioExample === "MENSUAL" ? 1 : 12)
                                ).toFixed(2) *
                                  parseFloat(UserAuth.cashDiscount)) /
                                100
                              ).toFixed(2)) *
                            (parseFloat(productInfo.iva) / 100)
                          ).toFixed(2)}
                    </b>
                  </Grid>
                  <Grid
                    item
                    xs={
                      productInfo.selectIVA === 0 ? 4 : radioPay === "E" ? 3 : 4
                    }
                    md={
                      productInfo.selectIVA === 0 ? 4 : radioPay === "E" ? 3 : 4
                    }
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      fontSize: 16,
                    }}
                  >
                    TOTAL: $
                    {radioPay !== "E"
                      ? (
                          (
                            parseFloat(productInfo.price) +
                            (parseFloat(productInfo.price) *
                              parseFloat(productInfo.iva)) /
                              100
                          ).toFixed(2) *
                          (radioExample === "MENSUAL"
                            ? 1
                            : radioPay === "CR"
                            ? values.monthCollection >= 1
                              ? parseFloat(values.monthCollection)
                              : 12
                            : 12)
                        ).toFixed(2)
                      : (
                          parseFloat(
                            (
                              parseFloat(productInfo.price) *
                              (radioExample === "MENSUAL" ? 1 : 12)
                            ).toFixed(2) -
                              (
                                ((
                                  parseFloat(productInfo.price) *
                                  (radioExample === "MENSUAL" ? 1 : 12)
                                ).toFixed(2) *
                                  parseFloat(UserAuth.cashDiscount)) /
                                100
                              ).toFixed(2)
                          ) +
                          parseFloat(
                            (
                              ((
                                parseFloat(productInfo.price) *
                                (radioExample === "MENSUAL" ? 1 : 12)
                              ).toFixed(2) -
                                (
                                  ((
                                    parseFloat(productInfo.price) *
                                    (radioExample === "MENSUAL" ? 1 : 12)
                                  ).toFixed(2) *
                                    parseFloat(UserAuth.cashDiscount)) /
                                  100
                                ).toFixed(2)) *
                              (parseFloat(productInfo.iva) / 100)
                            ).toFixed(2)
                          )
                        ).toFixed(2)}
                  </Grid>
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={12}
                  sx={{ display: radioPay === "CR" ? "none" : "block" }}
                >
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: 16,
                        pt: 3,
                        background: "#F6F6F6",
                      }}
                    >
                      <Typography
                        gutterBottom
                        sx={{
                          fontSize: 16,
                          fontWeight: "bold",
                          color: "#000",
                        }}
                      >
                        TOTAL A PAGAR:
                      </Typography>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      sx={{
                        textAlign: "center",
                        fontWeight: "bold",
                        fontSize: 18,
                        p: 2,
                        background: "#F6F6F6",
                        color: "#000",
                      }}
                    >
                      $
                      {radioPay !== "E"
                        ? (
                            (
                              parseFloat(productInfo.price) +
                              (parseFloat(productInfo.price) *
                                parseFloat(productInfo.iva)) /
                                100
                            ).toFixed(2) *
                            (radioPay === "CR"
                              ? values.monthCollection >= 1
                                ? parseFloat(values.monthCollection)
                                : 12
                              : 12)
                          ).toFixed(2)
                        : (
                            parseFloat(
                              (parseFloat(productInfo.price) * 12).toFixed(2) -
                                (
                                  ((parseFloat(productInfo.price) * 12).toFixed(
                                    2
                                  ) *
                                    parseFloat(UserAuth.cashDiscount)) /
                                  100
                                ).toFixed(2)
                            ) +
                            parseFloat(
                              (
                                ((parseFloat(productInfo.price) * 12).toFixed(
                                  2
                                ) -
                                  (
                                    ((
                                      parseFloat(productInfo.price) * 12
                                    ).toFixed(2) *
                                      parseFloat(UserAuth.cashDiscount)) /
                                    100
                                  ).toFixed(2)) *
                                (parseFloat(productInfo.iva) / 100)
                              ).toFixed(2)
                            )
                          ).toFixed(2)}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            )}
            <Grid item xs={12} sm={12} sx={{ margin: "40px 0 15px 0" }}>
              <center>
                <ButtonStyle0
                  onClick={submitSave}
                  endIcon={
                    <Save sx={{ display: loaderSave ? "none" : "block" }} />
                  }
                  disabled={loaderSave || viewCashDiscount}
                >
                  {loaderSave ? (
                    <>
                      <img
                        alt="loaderGif"
                        src={loaderGif}
                        style={{ width: 45, marginRight: 10 }} // Ajusta el tamaño y el margen
                      />
                      Registrando...
                    </>
                  ) : (
                    "Registrar"
                  )}
                </ButtonStyle0>
                {loaderSave && (
                  <div
                    className={classes.cardTitleBlack}
                    style={{ margin: "5px 0", fontSize: 10, fontWeight: 500 }}
                  >
                    Espere que se finalice el registro
                  </div>
                )}
              </center>
            </Grid>
          </>
        )}
      </Grid>

      {alert.openAlert && (
        <Snackbar
          open={true}
          autoHideDuration={10000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={handleCloseAlert}
        >
          <Slide direction="up" in={true} mountOnEnter unmountOnExit>
            <Alert
              onClose={handleCloseAlert}
              severity={alert.errorAlert === "error" ? "error" : "success"}
              elevation={6}
              variant="filled"
            >
              {alert.mensaje}
            </Alert>
          </Slide>
        </Snackbar>
      )}
      {openAddRegister && (
        <ClientSearch
          open={openAddRegister}
          exit={handleCloseAddRegister}
          dataSelect={handleSelectClient}
        />
      )}
    </Fragment>
  );
}
